import { ReduxStore } from 'store/types';

function changePasswordIsLoading(state: ReduxStore): boolean {
  return state.user.changePassword.config.isLoading;
}

export default changePasswordIsLoading;
